import React from "react"

import { Check, Briefcase, Users, Clock, Shield, MapPin, Lock } from "lucide-react"

const benefits = [
  {
    icon: Check,
    title: "Certified and Trained Technicians",
    description: "All our technicians are verified and trained professionals.",
  },
  {
    icon: Briefcase,
    title: "Transparent Pricing with no hidden costs",
    description: "Know exactly what you pay for with our upfront pricing model.",
  },
  {
    icon: Users,
    title: "Offers Responsive Customer Support",
    description: "Our team is available to assist you whenever you need help.",
  },
  {
    icon: Clock,
    title: "Ensures Cost-effectiveness",
    description: "Get the best value for your money with our competitive pricing.",
  },
  {
    icon: Shield,
    title: "Provides High-quality, Reliability and Safety",
    description: "We never compromise on quality, reliability, or your safety.",
  },
  {
    icon: MapPin,
    title: "Promotes Doorstep Services, Quick Response",
    description: "We come to you with fast response times for your convenience.",
  },
  {
    icon: Lock,
    title: "Guarantees Secure Transactions",
    description: "Your payments and personal information are always protected.",
  },
]

const AppShowcaseSection= () => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
          <div className="relative h-[500px] mx-auto w-full">
            <div className="absolute left-[10%] top-0 w-[40%] h-[90%] rounded-[30px] border-[8px] border-black overflow-hidden shadow-xl transform rotate-[-5deg]">
              <img
                src="https://images.unsplash.com/photo-1601972599720-36938d4ecd31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=387&q=80"
                alt="Hazer App on iPhone"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-0 right-0 text-center text-white text-xs">
                <div className="h-4 w-4 mx-auto rounded-full border border-white"></div>
              </div>
            </div>
            <div className="absolute right-[10%] top-[10%] w-[40%] h-[90%] rounded-[20px] border-[8px] border-black overflow-hidden shadow-xl transform rotate-[5deg]">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80"
                alt="Hazer App on Android"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-8 text-[#0072bc]">Why Choose Us?</h2>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-start bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="mr-4 mt-1 flex-shrink-0 bg-[#f0f8ff] p-2 rounded-full">
                    <benefit.icon className="h-5 w-5 text-[#0072bc]" />
                  </div>
                  <div>
                    <h3 className="font-medium text-[#333]">{benefit.title}</h3>
                    <p className="text-sm text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#"
                className="flex items-center bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 mr-2" fill="currentColor">
                  <path d="M17.5,2H8.5L3,7.5v9L8.5,22h9l5.5-5.5v-9L17.5,2z M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S15.9,19,12,19z M12,7c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S14.8,7,12,7z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,15,12,15z" />
                </svg>
                Download on App Store
              </a>
              <a
                href="#"
                className="flex items-center bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 mr-2" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.1,4.1,1,5.5,1h13C19.9,1,21,2.1,21,3.5v17c0,1.4-1.1,2.5-2.5,2.5h-13C4.1,23,3,21.9,3,20.5z M12,7V5.5C12,5.2,11.8,5,11.5,5h-2C9.2,5,9,5.2,9,5.5V7h3z M9,17v1.5C9,18.8,9.2,19,9.5,19h2c0.3,0,0.5-0.2,0.5-0.5V17H9z M12,16v-6H9v6H12z M13,10h2v1h-2V10z M13,12h2v1h-2V12z M13,14h2v1h-2V14z M15,16h-2v1h2V16z" />
                </svg>
                Get it on Google Play
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AppShowcaseSection